import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientStaffingPage from "@/pages/client/ClientStaffingPage";

export const Route = createFileRoute("/client/staffing")({
  head: () => pageHead("Client · Staffing", "AKIVA client · staffing portal.", "/client/staffing", true),
  component: ClientStaffingPage,
});
